import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toggle: false,
};

export const togglerSlice = createSlice({
  name: "toggler",
  initialState,
  reducers: {
    toggle: (state) => {
      state.toggle = !state.toggle;
    },
  },
});

export const { toggle } = togglerSlice.actions;

export default togglerSlice.reducer;
